import {createAction} from '@reduxjs/toolkit'

import {OldMemoInfo, DeliveryInfoState} from '../interfaces'

type ItemId = string

/** 배송지 개별입력 선택 */
export const selectParticularInput = createAction<boolean>('deliveryInfo/selectParticularInput')

/** 배송지 메모 통합 입력 */
export const inputIndividuallyMemo = createAction<string>('deliveryInfo/inputIndividuallyMemo')

/** 배송지 메모 개별 입력 */
export const inputParticularMemo = createAction<[ItemId, string]>('deliveryInfo/inputParticularMemo')

export type InputDeliveryMemo = {
    id: Maybe<string>
    data: OldMemoInfo
}

/** 배송 메모 선택 */
export const inputDeliveryMemo = createAction<InputDeliveryMemo>('delivery/inputDeliveryMemo')

/** 수령위치/출입방법 업데이트 */
export const updateDeliveryInstruction = createAction<DeliveryInfoState['pickup']>(
    'deliveryInfo/updateDeliveryInstruction',
)

/** 배송 메모 다음에도 사용 여부 업데이트 */
export const changeSaveAsDefaultMemo = createAction<boolean>('deliveryInfo/changeSaveAsDefaultMemo')
